import { Dropdown } from 'antd';
import React from 'react';
// import { Link } from 'react-router-dom';
import { DropDownBox } from '../../../components/dropdown-box';
import { IAPIUserInfo } from '../../../model/api-modules';
import accountIcon from '../../../assets/img/account-icon.png';
import { formatEmailName } from '../../../lib/email';
import getFormatMessage from '../../../locales/get-format-message';
import { useHistory } from 'react-router-dom';
import { getConfig, isSupportSystem } from '../../../config';
import { getLocaleLanguage, LanguageType, openURL } from '../../../lib';

interface IProps {
  readonly onLogout: () => Promise<boolean>;
  readonly onAccountCenter: () => void;
  readonly userInfo: IAPIUserInfo;
  readonly noDownloadCenter?: boolean;
  readonly lang?: LanguageType | null;
}

export const ItemUserComponent = (props: IProps) => {
  const { consoleURL } = getConfig();
  const history = useHistory();
  const currentLanguage = props.lang || getLocaleLanguage();
  const getUsername = () => {
    return formatEmailName(props.userInfo.UserName || props.userInfo.UserID);
  };
  let userItems = [
    {
      key: '1',
      // label: <Link to={'/account'}>Account Center</Link>,
      label: (
        <>
          <div className="account-text ellipsis">{getUsername()}</div>
          <div className="account-text2 ellipsis">
            {props.userInfo.UserID}
            <span className="account-line"></span>
          </div>
        </>
      ),
      className: 'dropdown-item-user',
    },
    {
      key: '2',
      // label: <Link to={'/account'}>Account Center</Link>,
      label: getFormatMessage(
        'account_label',
        {},
        currentLanguage || LanguageType.en_US
      ),
      onClick: () => {
        props.onAccountCenter();
      },
    },
    {
      key: '4',
      label: getFormatMessage(
        'download_center',
        {},
        currentLanguage || LanguageType.en_US
      ),
      onClick: () => {
        if (isSupportSystem()) {
          openURL(`${consoleURL}/download/download-center`);
          return;
        }
        history.push('/download/download-center');
      },
    },
    {
      key: '3',
      label: getFormatMessage(
        'sign_out_label',
        {},
        currentLanguage || LanguageType.en_US
      ),
      onClick: () => {
        props.onLogout();
      },
    },
  ];

  if (isSupportSystem() || props.noDownloadCenter) {
    userItems = userItems.filter((item) => item.key !== '4');
  }

  return (
    <Dropdown
      menu={{ items: userItems }}
      destroyPopupOnHide={true}
      overlayClassName="logo-dropdown-bottom"
      placement="bottomRight"
    >
      <a className="action-account action-account-user">
        <DropDownBox
          className="drop-down-box"
          hasArrow={false}
          fontSize={16}
          title={<img src={accountIcon} />}
        />
      </a>
    </Dropdown>
  );
};
